import { render, staticRenderFns } from "./PersonaliaComponent.vue?vue&type=template&id=4475c930&scoped=true&"
import script from "./PersonaliaComponent.vue?vue&type=script&lang=js&"
export * from "./PersonaliaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4475c930",
  null
  
)

export default component.exports